/**
 * First-order reminder (BACKLOG #46, nudge 1). A small bubble on the main
 * product photo: "you have 10 % off your first order" + "Aplicar oferta".
 *
 * Rules: once per visit (closed or not), only after `delay` seconds on the
 * page and only while the photo is on screen, never inside the quick-add
 * pop-up. Liquid already left it out for customers with orders and for carts
 * that carry any code. With the A/B holdout on, half of the visitors are kept
 * as a control group: they get the same "eligible" event but no bubble.
 *
 * "Aplicar oferta" calls /discount/<code>, which puts the code on the cart
 * (it stays there even while the cart is empty), then tells the product page
 * to show the discounted prices (event brisato:offer).
 *
 * Liquid's cart.discount_codes is empty while the cart is, so on every load
 * the `discount_code` cookie is checked here too: a code already on the cart
 * means no bubble, and if it is ours, discounted prices.
 */
(() => {
  const el = document.querySelector('[data-offer-nudge]');
  if (!el || el.closest('dialog') || window.BrisatoNudge) return;
  window.BrisatoNudge = true;

  const code = el.dataset.code;
  const percent = Number(el.dataset.percent) || 10;
  const cookie = document.cookie.split('; ').find((c) => c.indexOf('discount_code=') === 0);
  if (cookie) {
    const onCart = decodeURIComponent(cookie.slice('discount_code='.length)).split(',');
    if (onCart.some((c) => c.trim().toLowerCase() === code.toLowerCase())) {
      document.dispatchEvent(new CustomEvent('brisato:offer', { detail: { code, percent } }));
    }
    return;
  }
  if (el.dataset.offerNudge !== 'true') return;

  const track = (name, data = {}) => {
    if (typeof window.brisatoTrack === 'function') window.brisatoTrack(name, data);
  };
  const store = (area, key, value) => {
    try {
      if (value === undefined) return window[area].getItem(key);
      window[area].setItem(key, value);
    } catch (_) {
      /* private mode: behave as a first visit */
    }
    return null;
  };

  const SEEN = 'bst_nudge_visit';
  if (store('sessionStorage', SEEN)) return;

  // A/B bucket, kept per browser so a visitor stays in one group
  let variant = 'on';
  if (el.dataset.holdout === 'true') {
    variant = store('localStorage', 'bst_nudge_ab');
    if (variant !== 'on' && variant !== 'off') {
      variant = Math.random() < 0.5 ? 'on' : 'off';
      store('localStorage', 'bst_nudge_ab', variant);
    }
  }

  const product = window.location.pathname.split('/').pop();
  const photo = el.parentElement.querySelector('[data-track]') || el.parentElement;
  let onScreen = false;
  let due = false;
  let done = false;

  // The photo can be taller than the screen (laptops): keep the bubble inside
  // the part of the photo that is visible, never below the fold.
  const place = () => {
    const box = el.parentElement.getBoundingClientRect();
    const hidden = Math.max(0, box.bottom - window.innerHeight);
    el.style.bottom = hidden > 0 ? `${hidden + 16}px` : '';
  };

  const show = () => {
    if (done || !due || !onScreen) return;
    done = true;
    place();
    window.addEventListener('resize', place, { passive: true });
    store('sessionStorage', SEEN, '1');
    track('nudge_eligible', { nudge: 'first_order', variant, product });
    if (variant === 'off') return;
    el.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-on')));
    track('nudge_shown', { nudge: 'first_order', product });
  };

  const hide = () => {
    el.classList.remove('is-on');
    window.setTimeout(() => { el.hidden = true; }, 400);
  };

  new IntersectionObserver((entries) => {
    onScreen = entries[entries.length - 1].intersectionRatio >= 0.5;
    show();
  }, { threshold: [0, 0.5, 1] }).observe(photo);

  window.setTimeout(() => { due = true; show(); }, (Number(el.dataset.delay) || 5) * 1000);

  el.querySelector('[data-nudge-close]').addEventListener('click', () => {
    track('nudge_close', { nudge: 'first_order', product });
    hide();
  });

  const apply = el.querySelector('[data-nudge-apply]');
  const text = el.querySelector('[data-nudge-text]');
  const say = (selector) => {
    text.innerHTML = el.querySelector(selector).innerHTML;
    apply.remove();
    el.querySelector('[data-nudge-close]').hidden = selector === '[data-nudge-done]';
  };

  apply.addEventListener('click', async () => {
    apply.disabled = true;
    track('nudge_apply', { nudge: 'first_order', product });
    let ok = false;
    try {
      const res = await fetch(`/discount/${encodeURIComponent(code)}?redirect=%2Fcart.js`, { credentials: 'same-origin' });
      const cart = await res.json();
      ok = (cart.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase());
    } catch (_) {
      ok = false;
    }
    if (ok) {
      el.classList.add('is-done');
      say('[data-nudge-done]');
      document.dispatchEvent(new CustomEvent('brisato:offer', { detail: { code, percent } }));
      window.setTimeout(hide, 2600);
    } else {
      say('[data-nudge-failed]');
    }
  });
})();
